var map = {
	"./404.svg": 939,
	"./Categories.png": 940,
	"./Edit-menu.svg": 941,
	"./Egg.svg": 942,
	"./Emaier-Header.png": 943,
	"./Qr-4.png": 944,
	"./_duplicate.svg": 945,
	"./_overview.svg": 946,
	"./add-white.svg": 947,
	"./alert.svg": 948,
	"./all_category.svg": 949,
	"./archive.svg": 950,
	"./armchair.svg": 951,
	"./arrow-circle-right.svg": 952,
	"./arrow-left-circle.svg": 953,
	"./arrow-right-circle.svg": 954,
	"./arrow-right.svg": 352,
	"./asc-up-white.svg": 955,
	"./asc.png": 956,
	"./asc.svg": 957,
	"./back-arrow.svg": 958,
	"./barcode-icon.svg": 959,
	"./beverages.svg": 960,
	"./blue-edit-pen.svg": 961,
	"./blue-eye.svg": 962,
	"./box-office.svg": 963,
	"./broken-seat.jpg": 964,
	"./calendar_list.svg": 965,
	"./chevron-down.svg": 966,
	"./chevron-left.svg": 967,
	"./cinema-mamagement-sidebar.svg": 968,
	"./claendar.svg": 302,
	"./clock-1.svg": 969,
	"./clock.svg": 970,
	"./close-button.svg": 700,
	"./close-white.svg": 702,
	"./close-x.svg": 297,
	"./collapse-up.svg": 971,
	"./collapse.svg": 972,
	"./connection-lost.svg": 350,
	"./copy.svg": 973,
	"./copy_image_icon.png": 974,
	"./delete-red-light.svg": 975,
	"./delete-red.svg": 708,
	"./delete.svg": 685,
	"./deliver-icon.svg": 976,
	"./desc-down-white.svg": 977,
	"./desc.svg": 978,
	"./distributors-sidebar.svg": 979,
	"./download.svg": 980,
	"./dragndrop.svg": 981,
	"./dragndrop2.svg": 982,
	"./duplicate.svg": 983,
	"./duplicateScreen.svg": 984,
	"./e-wallet-icon-black.svg": 985,
	"./edit-pen-blue.svg": 986,
	"./edit-pen-white.svg": 987,
	"./edit-pen.svg": 988,
	"./edit.svg": 989,
	"./email.png": 990,
	"./empty-image.svg": 991,
	"./excel.svg": 992,
	"./external-link.svg": 993,
	"./eye.svg": 994,
	"./filter-icon.svg": 995,
	"./flag.svg": 996,
	"./fnb-app-order.svg": 997,
	"./fnb-beverages.svg": 998,
	"./fnb-brownie.svg": 999,
	"./fnb-combo.svg": 1000,
	"./fnb-desert.svg": 1001,
	"./fnb-eatables.svg": 1002,
	"./fnb-make-your-combo.svg": 1003,
	"./fnb-popcorn.svg": 1004,
	"./fnbtransactionIcon.svg": 1005,
	"./fullscreen-icon.svg": 709,
	"./funnel.svg": 1006,
	"./globe.svg": 1007,
	"./green-tick.svg": 1008,
	"./grid-view.svg": 1009,
	"./hide-password.svg": 353,
	"./home-icon.svg": 1010,
	"./home.svg": 1011,
	"./icon-black-play.svg": 1012,
	"./icon-dot.svg": 1013,
	"./icon-fnb.svg": 1014,
	"./icon-marketing.svg": 1015,
	"./icon-no-seat.png": 1016,
	"./icon-no-seat.svg": 1017,
	"./icon-option.svg": 1018,
	"./icon-poin-of-sale.svg": 1019,
	"./icon-recliner.svg": 1020,
	"./icon-report.svg": 1021,
	"./icon-sofa-dark-1.svg": 1022,
	"./icon-sofa-dark.png": 1023,
	"./icon-sofa-dark.svg": 1024,
	"./icon-sofa.svg": 1025,
	"./importfile.svg": 1026,
	"./info.svg": 703,
	"./info2.svg": 1027,
	"./keyboard-icon.svg": 1028,
	"./kitchen_display.svg": 1029,
	"./language-icon.svg": 298,
	"./left-caret.svg": 1030,
	"./link.svg": 1031,
	"./list-view.svg": 1032,
	"./loading.svg": 354,
	"./lock.svg": 1033,
	"./login-password.png": 355,
	"./login-user.png": 356,
	"./logout.svg": 704,
	"./masters-sidebar.svg": 1034,
	"./merchandise.svg": 1035,
	"./minus.svg": 1036,
	"./movie-pass-svg.svg": 691,
	"./movie-rolling.svg": 1037,
	"./mulitSchedule.svg": 1038,
	"./multicurrency.svg": 1039,
	"./multifnb.svg": 1040,
	"./nav-plus.svg": 1041,
	"./new_filter_icon.svg": 1042,
	"./no-image.svg": 1043,
	"./no-schedule.svg": 133,
	"./non-veg-mark.png": 1044,
	"./non-veg-mark.svg": 1045,
	"./notification.svg": 1046,
	"./open-link-blue.svg": 1047,
	"./openPlanned.svg": 1048,
	"./overview.svg": 1049,
	"./overview2.svg": 1050,
	"./pdf-icon.svg": 1051,
	"./pdf.svg": 1052,
	"./pickup-ticket-icon.svg": 1053,
	"./pickupfnb.svg": 1054,
	"./play.svg": 1055,
	"./plus.svg": 1056,
	"./pointofsale-1.svg": 1057,
	"./pointofsale-2.svg": 1058,
	"./pointofsale.png": 1059,
	"./portfolio.svg": 1060,
	"./pos-fnb-no-itmes.svg": 697,
	"./pos-refresh.svg": 1061,
	"./primary/chevron-down.svg": 1062,
	"./primary/download.svg": 1063,
	"./primary/edit.svg": 1064,
	"./primary/filter.svg": 1065,
	"./primary/printer.svg": 1066,
	"./print-icon.svg": 1067,
	"./print.svg": 1068,
	"./question.svg": 1069,
	"./question1.svg": 1070,
	"./question2.svg": 710,
	"./question3.svg": 1071,
	"./recliner-1.svg": 1072,
	"./recliner.png": 1073,
	"./refund-icon.svg": 1074,
	"./reload-icon-pos.svg": 1075,
	"./reload-icon.svg": 1076,
	"./restore.svg": 1077,
	"./right-caret.svg": 1078,
	"./role-management-sidebar.svg": 1079,
	"./save.svg": 1080,
	"./schedule-icon.svg": 1081,
	"./school-calendar.svg": 1082,
	"./search-global-white.svg": 1083,
	"./search-global.svg": 1084,
	"./search.svg": 711,
	"./searchIcon.svg": 1085,
	"./seat-icon-2.svg": 1086,
	"./seat-icon.svg": 1087,
	"./seat-icons/3-wheelChair.png": 1088,
	"./seat-icons/block_seat_new.png": 1089,
	"./seat-icons/broken-seat-1.svg": 1090,
	"./seat-icons/broken-seat-2.svg": 1091,
	"./select-food.png": 712,
	"./settings.svg": 1092,
	"./show-password.svg": 357,
	"./slider-triangle.svg": 1093,
	"./snack.svg": 705,
	"./sort.svg": 1094,
	"./star-empty.svg": 1095,
	"./star-fill.svg": 1096,
	"./success-tick.svg": 1097,
	"./suitcase.svg": 1098,
	"./swap.svg": 1099,
	"./tick-green-item.svg": 713,
	"./tick-green.svg": 1100,
	"./ticket-icon.svg": 1101,
	"./trash.svg": 1102,
	"./unpaid-reservation.svg": 687,
	"./updown-white.svg": 1103,
	"./updown.svg": 1104,
	"./user-attribute.svg": 1105,
	"./user-attributes.svg": 1106,
	"./user-female.svg": 1107,
	"./user-male-white.svg": 1108,
	"./user-male.svg": 1109,
	"./user-profile.svg": 1110,
	"./userProfile.png": 1111,
	"./veg-food-mark-white.png": 1112,
	"./veg-foog-mark-trans.png": 1113,
	"./view.png": 1114,
	"./view.svg": 1115
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 938;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 938
// module chunks = 33